import { Link } from 'react-router-dom';
import '../../css/common.css'
import work from '../../img/portfolio-black.png';
import hobbies from '../../img/hobbies-black.png';
import projects from '../../img/project-black.png';
import contact from '../../img/chat-black.png';
import flickr from '../../img/flickr.png';
import twitter from '../../img/twitter.png';
import mastodon from '../../img/mastodon.png';
import youtube from '../../img/youtube.png';
import instagram from '../../img/instagram.png';
import imodeler from '../../img/imodeler.png';
import goodreads from '../../img/goodreads-icon.png';
import linkedin from '../../img/linkedin.png';
import github from '../../img/github-logo.png';
import thingiverse from '../../img/thingiverse-logo.png'
import q500px from '../../img/500px.png';
import alienado from '../../img/El_hombre_alienado5157117929540108178.jpg';
import spacer from '../../img/img1x1.png';
import pdf_logo from '../../img/pdf.png';

let inicio_es = (<div>
    Hola, soy <strong>Alfredo Cofré</strong>, ingeniero chileno. Llevo muchos años construyendo software y levantando
    proyectos de telecomunicaciones: apps móviles, sistemas de IPTV, infraestructura cloud, etc. He trabajado en proyectos
    que terminaron en enormes billboards sobre las autopistas y en el hogar de millones de personas de Chile, Puerto Rico, Costa Rica, Panamá y
    el Caribe. Soy ferozmente curioso y me gusta entender cómo funciona todo lo que toco, y me gusta más cuando puedo construirlo
    con mis propias manos.
    <p></p>
    Más allá de lo profesional, me interesan además y gasto enormes esfuerzos en temas tales como fotografía, drones, modelismo,
    modelado e impresión 3D, carpintería, ciclismo, artes marciales, soldadura al arco, etc. Este sitio es un registro de aquello.
   </div>);

let inicio_en = (<div>
    Hi, I'm <strong>Alfredo Cofré</strong>, chilean <strong>software engineer</strong>. I've spent years building
    software and developing telecommunications projects: mobile apps, IPTV systems, cloud infrastructure, and more. I've worked
    in projects that ended up on huge billboards along highways and in the homes of millions of people in Chile, Puerto Rico,
    Costa Rica, Panama and the Caribbean. I'm fiercely curious and I like to understand how everything I touch works, and if
    I can build it myself, even better.
    <p></p>
    Beyond my professional life, I'm also interested in and dedicate considerable effort to things like photography, drones, models making,
    3D modeling and printing, woodworking, cycling, martial arts, arc welding, and more. This site is a record of such.
   </div>);

let inicio = inicio_es;

let text1_es = (<div>
    Más de 20 años en desarrollo de software y telecomunicaciones.
    Desde apps móviles y desarrollo fullstack en muchos sabores hasta IPTV en producción en múltiples países, pasando por SRE,
    infraestructura en GCP, AWS, VMWare, dockers y bare-metal, y gestión de operaciones.
    </div>);

let text1_en = (<div>
    Over 20 years in software development and telecommunications.
    From mobile apps and fullstack dev in many flavours to IPTV in production across multiple countries, including SRE, infrastructure in
    GCP, AWS, VMWware, dockers and bare-metal, and operations management.
</div>);

let text2_es = (<div>
    Fotografía, aerovideografía, modelismo a escala, impresión 3D, lectura, ciclismo, boxeo, etc.
    Tengo más proyectos personales que tiempo, pero eso nunca me ha detenido.
    </div>);

let text2_en = (<div>
    Photography, aerial videography, scale modeling, 3D printing, reading, cycling, boxing, etc.
    I have more personal projects than time, but that never stops me.
</div>);

let text3_es = (<div>
    Pequeño mostrario de cosas que construí porque me dieron ganas o porque las necesitaba y no existían.
    Widgets, libros de fotografía, dioramas, modelos y otras cosas raras.
</div>);

let text3_en = (<div>
    A small collection of things I built either because I felt like it or because I needed them and they didn't exist.
    Widgets, photography books, dioramas, models, and other oddities.
</div>);

let text_contact_es = (<div>
    Si tienes un problema interesante o una idea que necesita a alguien que pueda ejecutarla, hablemos.
</div>);

let text_contact_en = (<div>
    If you have an interesting problem or an idea that needs someone to execute it, let's talk.
</div>);

let text5_es = (<div>Encuéntrame en</div>);
let text5_en = (<div>Find me at</div>);

let whatsnew_es = (<div>Así que... ¿qué hay de nuevo aca?</div>);
let whatsnew_en = (<div>So.. what's new in here?</div>);

let newwork1_es = (<div>Actualicé mi CV e historial profesional, incluyendo ahora mi tiempo en <strong><a href="https://cordada.com" target="_blank" rel="noreferrer">Cordada.com</a></strong>.</div>);
let newwork1_en = (<div>I updated my resume, and professional timeline, now including my time at <strong><a href="https://cordada.com" target="_blank" rel="noreferrer">Cordada.com</a></strong>.</div>);

let project1_es = (<div>Recordamos la creación de mi libro <strong><Link to="/projects#cefalofotografo">Cefalofotógrafo</Link></strong>.</div>);
let project1_en = (<div>We rememorate the creation of my book <strong><Link to="/projects#cefalofotografo">Cefalofotógrafo</Link></strong>.</div>);

let project2_es = (<div>Creé un pequeño widget de React para poder incluir un stream de Flickr en un sitio React site. Lo llamamos <strong><Link to="/projects#flickrFlow">flickrFlow</Link></strong>.</div>);
let project2_en = (<div>I created a small React widget for displaying a Flickr stream in a React site. We called it <strong><Link to="/projects#flickrFlow">flickrFlow</Link></strong>.</div>);

let text1 = text1_es;
let text2 = text2_es;
let text3 = text3_es;
let text_contact  = text_contact_es;
let text5 = text5_es
let whatsnew = whatsnew_es;
let newwork1 = newwork1_es;
let project1 = project1_es;
let project2 = project2_es;

export function Me(props){

    const lang = props.lang;

    switch(lang){
        case "en":
            inicio = inicio_en;
            text1 = text1_en;
            text2 = text2_en;
            text3 = text3_en;
            text_contact = text_contact_en;
            text5 = text5_en;
            whatsnew = whatsnew_en;
            newwork1 = newwork1_en;
            project1 = project1_en;
            project2 = project2_en;
            break;
        case "es":
        default:
            inicio = inicio_es;
            text1 = text1_es;
            text2 = text2_es;
            text3 = text3_es;
            text_contact = text_contact_es;
            text5 = text5_es;
            whatsnew = whatsnew_es;
            newwork1 = newwork1_es;
            project1 = project1_es;
            project2 = project2_es;
            break;
    }

    let text_structure = (
        <div>
            <p>{inicio}</p>
            <article name='inicio' className='noPadding'>
                <div className='table'>
                    <div className='rowRealignable'>
                        <div className='col round'>
                            <img src={alienado} alt=""/>
                        </div>
                        <div className='col'>
                            <div className='me'>
                                <ul>
                                    <li><div className='inline'><img src={work} alt=""/>&nbsp;&nbsp;{text1}</div></li>
                                    <li><div className='inline'><img src={hobbies} alt=""/>&nbsp;&nbsp;{text2}</div></li>
                                    <li><div className='inline'><img src={projects} alt=""/>&nbsp;&nbsp;{text3}</div></li>
                                    <li><div className='inline'><img src={contact} alt=""/>&nbsp;&nbsp;{text_contact}</div></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
            <p>{text5}</p>
            <div>
                <article name="links">
                    <div className='table'>
                        <div className='row'>
                            <div className='col centered'>
                                <a href="https://flickr.com/kurakensama" target="_blank" rel="noreferrer"><img className='space3' src={flickr} width="32px;" alt="flickr"/></a>
                            </div>
                            <div className='col centered'>
                                <img src={spacer} width="10px;" alt=""/>
                            </div>
                            <div className='col'>
                                <a href="https://500px.com/p/kurakensama" target="_blank" rel="noreferrer"><img className='space3' src={q500px} width="32px;" alt="500px"/></a>
                            </div>
                            <div className='col centered'>
                                <img src={spacer} width="10px;" alt=""/>
                            </div>
                            <div className='col'>
                                <a href="https://www.twitter.com/kurakensama" target="_blank" rel="noreferrer"><img className='space3' src={twitter} width="32px;" alt="twitter"/></a>
                            </div>
                            <div className='col centered'>
                                <img src={spacer} width="10px;" alt=""/>
                            </div>
                            <div className='col'>
                                <a href="https://lile.cl/@kurakensama" target="_blank" rel="noreferrer"><img className='space3' src={mastodon} width="32px;" alt="mastodon"/></a>
                            </div>
                            <div className='col centered'>
                                <img src={spacer} width="10px;" alt=""/>
                            </div>
                            <div className='col'>
                                <a href="https://www.youtube.com/@SouthDronography" target="_blank" rel="noreferrer"><img className='space3' src={youtube} width="32px;" alt="youtube"/></a>
                            </div>
                            <div className='col centered'>
                                <img src={spacer} width="10px;" alt=""/>
                            </div>
                            <div className='col'>
                                <a href="https://www.instagram.com/kurakensama/" target="_blank" rel="noreferrer"><img className='space3' src={instagram} width="32px;" alt="instagram"/></a>
                            </div>
                            <div className='col centered'>
                                <img src={spacer} width="10px;" alt=""/>
                            </div>
                            <div className='col'>
                                <a href="https://www.linkedin.com/in/acofre/" target="_blank" rel="noreferrer"><img className='space3' src={linkedin} width="32px;" alt="linked.in"/></a>
                            </div>
                            <div className='col centered'>
                                <img src={spacer} width="10px;" alt=""/>
                            </div>
                            <div className='col'>
                                <a href="https://github.com/kurakensama" target="_blank" rel="noreferrer"><img className='space3' src={github} width="32px;" alt="github"/></a>
                            </div>
                            <div className='col centered'>
                                <img src={spacer} width="10px;" alt=""/>
                            </div>
                            <div className='col'>
                                <a href="https://www.thingiverse.com/kurakensama/designs" target="_blank" rel="noreferrer"><img className='space3' src={thingiverse} width="32px;" alt="thingiverse"/></a>
                            </div>
                            <div className='col centered'>
                                <img src={spacer} width="10px;" alt=""/>
                            </div><div className='col'>
                                <a href="https://imodeler.com/members/alfredo_cofre/" target="_blank" rel="noreferrer"><img className='space3' src={imodeler} width="32px;" alt="imodeler"/></a>
                            </div>
                            <div className='col centered'>
                                <img src={spacer} width="10px;" alt=""/>
                            </div>
                            <div className='col'>
                                <a href="https://www.goodreads.com/author/show/6983517.Alfredo_Cofr_" target="_blank" rel="noreferrer"><img className='space3' src={goodreads} width="32px;" alt="goodreads"/></a>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
             <p>{whatsnew}</p>
            <article name='whatsnew'>
                <img src={work} height="32px;"/>
                <p></p>
                {newwork1}
            </article>
            <p></p>
            <article name='cefalofotografo'>
                <img src={projects} height="32px;"/>
                <p></p>
                {project1}
            </article>
            <p></p>
            <article name='flickrFlow'>
                <img src={projects} height="32px;"/>
                <p></p>
                {project2}
            </article>
        </div>
    );




    return(<div>{text_structure}</div>);
}